import * as uuid from 'uuid';
export const reduce = (orderLines, fn, initial) => {
    let acc = initial;
    orderLines.forEach((ol) => {
        acc = fn(acc, ol);
        if (ol.subLines.length > 0) {
            acc = reduce(ol.subLines, fn, acc);
        }
    });
    return acc;
};
export const reduceWithParent = (orderLines, fn, initial, parent) => {
    let acc = initial;
    orderLines.forEach((ol) => {
        if (ol.subLines.length > 0) {
            acc = reduceWithParent(ol.subLines, fn, acc, ol);
        }
        acc = fn(acc, ol, parent);
    });
    return acc;
};
export const reduceRightWithParent = (orderLines, fn, initial, parent) => {
    let acc = initial;
    orderLines
        .slice(0)
        .reverse()
        .forEach((ol) => {
        if (ol.subLines.length > 0) {
            acc = reduceWithParent(ol.subLines, fn, acc, ol);
        }
        acc = fn(acc, ol, parent);
    });
    return acc;
};
export const reduceRight = (orderLines, fn, initial) => reduce(orderLines, (acc, curr) => [curr, ...acc], []).reduce(fn, initial);
export function computeTotalPrice(topLevelOrderLines) {
    reduceRight(topLevelOrderLines, (acc, curr) => {
        curr.virtualId = uuid.v4();
        return null;
    }, null);
    const r1 = reduceWithParent(topLevelOrderLines, (acc, curr, parent) => {
        const currentAccValue = acc.accumulations[curr.virtualId] || 0;
        if (parent === null) {
            if (curr.type === 'Discount' || curr.type === 'FreeMeal' || curr.type === 'Delivery') {
                return Object.assign(Object.assign({}, acc), { total: acc.total + curr.totalPrice });
            }
            if (curr.type === 'CombinatorLine') {
                return Object.assign(Object.assign({}, acc), { total: acc.total + curr.totalPriceAccum });
            }
            const calculateLineTotal = (currentValue, currentOrderLine) => {
                if (currentOrderLine.type !== 'Product') {
                    return currentValue;
                }
                if (currentOrderLine.discountQuantity > 0 && currentOrderLine.quantity > currentOrderLine.discountQuantity) {
                    return currentOrderLine.totalPrice;
                }
                if (!currentOrderLine.price) {
                    return currentValue;
                }
                return (currentValue + currentOrderLine.price) * (currentOrderLine.quantity || 1);
            };
            const lineTotal = calculateLineTotal(currentAccValue, curr);
            return {
                accumulations: acc.accumulations,
                total: acc.total + lineTotal,
            };
        }
        if (parent !== null && parent.type !== 'CombinatorLine') {
            const parentAcc = acc.accumulations[parent.virtualId] || 0;
            if (curr.type === 'Product') {
                if (parent.options && parent.options.freeQuantity) {
                    return {
                        accumulations: Object.assign(Object.assign({}, acc.accumulations), { [parent.virtualId]: 'totalPriceAccum' in parent ? parent.totalPriceAccum : 0 }),
                        total: acc.total,
                    };
                }
                return {
                    accumulations: Object.assign(Object.assign({}, acc.accumulations), { [parent.virtualId]: parentAcc + (currentAccValue + (curr.price || 0)) * (curr.quantity || 1) }),
                    total: acc.total,
                };
            }
            else {
                const currentValue = curr.type === 'CombinatorLine' ? curr.totalPriceAccum : currentAccValue;
                return {
                    accumulations: Object.assign(Object.assign({}, acc.accumulations), { [parent.virtualId]: parentAcc + currentValue }),
                    total: acc.total,
                };
            }
        }
        return acc;
    }, { total: 0, accumulations: {} }, null);
    return r1.total;
}
export function makeOrderLinesBackwardsCompatibleG5(topLevelOrderLines) {
    return topLevelOrderLines.map((ol) => {
        if ('type' in ol && ol.type === 'Nps') {
            return Object.assign(Object.assign({}, ol), { type: 'Meta' });
        }
        return ol;
    });
}
